export default {
  newPending: 0,
  pending: 1,
  isNull: 2,
  verified: 3,
  verifyBypass: 4,
};
